var Stats = require('/src/lib/util/math/stats');
var scoredAttributes = require('./scored-attributes');

const scoreCard = function(card) {
	const attrs = scoredAttributes(card);
	const baseScore = 0.68139288 * (attrs.cmc * attrs.isRare)
		+ 0.095148054 * (attrs.cmc * attrs.isInstant)
		+ 0.14260149 * (attrs.power * attrs.toughness)
		+ 0.018756034 * (attrs.toughness * attrs.isCommon)
		+ -0.10728534 * (attrs.abilities * attrs.isUncommon)
		+ -0.35948820 * (attrs.abilities * attrs.isCreature)
		+ 0.82597670 * (attrs.abilitiesWordCount * attrs.isRare)
		+ 0.71633090 * (attrs.abilitiesWordCount * attrs.isMythic)
		+ 0.0094595577 * (attrs.abilitiesWordCount * attrs.isInstant)
		+ 1.7542067 * (attrs.abilitiesWordCount * attrs.isSorcery)
	 + 25.198131;

	 // redistribute scores from about 0 to 1, flattening out the growth at the
	 // extreme end, where some odd outliers upwards of 150 (and up to ~1450) would
	 // otherwise really skew the distribution.
	 return (1 - Math.pow(0.000001, baseScore/1500))/0.999999;
};

globalThis.scoreCard = scoreCard;

module.exports = function(cards) {
	this.cardCount = cards.reduce(function(sum, card) {
		return sum + Number(card.quantity);
	}, 0);

	this.scores = cards.map(function(card) {
		return Number(card.quantity) * scoreCard(card);
	});

	this.totalScore = Stats.sum(this.scores);
	this.average = this.totalScore / this.cardCount;
	this.median = Stats.median(this.scores);

	// console.log(this);

	// possible ways to maximize on deck speed/efficiency:
	//
	// y=(e^((x-2)^2/-4))/1, y=(e^((x-5)^2/-8))/1, y=(e^((x-8)^2/-16))/1
	// y=1/(((x-2.5)/1)^2 + 1), y=1/(((x-5)/2)^2 + 1), y=1/(((x-8)/2)^2 + 1)
	// y=(1-(x-2)^(1/3)/2)
	// y=0.5-arctan(x-pi)/(2*arctan(2^32))
	//

	
};